<template>
  <Aggregate
    title="Project Reserves"
    v-model="computedValue"
    :ItemConstructor="CaseModel.ReserveProject"
    :cardProps="{ outlined: true, class: [] }"
    toolbar-dense
    dense
    @change="$emit('change')"
  >
    <template #[`item.name`]="{ item }">
      <v-text-field v-model="item.name" @change="updateWhereAssigned(item.id, item.name)" />
    </template>
    <template #default="{ item }">
      <v-text-field
        v-model.number="item.param.duration"
        label="Duration (hours)"
        suffix="hours"
        type="number"
        @change="$emit('change')"
      ></v-text-field>
      <v-switch
        v-model="item.set_reserved_capacity"
        label="Set Reserved Capacity"
        hint="Set a reserved capacity instead of taking reserve price from Market"
        persistent-hint
        @change="$emit('change')"
      ></v-switch>
      <v-text-field
        v-if="item.set_reserved_capacity"
        v-model.number="item.param.capacity"
        class="my-5"
        label="Reserved Capacity"
        hint="Remember to add the Reserve service to the generators and storages"
        persistent-hint
        suffix="MW"
        type="number"
        @change="$emit('change')"
      ></v-text-field>
    </template>
  </Aggregate>
</template>

<script>
import { CaseModel } from "data-dictionary";

export default {
  name: "SystemProjectReserve",
  components: {
    Aggregate: () => import("@/components/Aggregate.vue"),
  },
  mixins: [],
  props: {
    value: { type: Array, required: true },
    project: { type: Object, required: true },
    num_years: { type: Number, required: true },
    errors: {
      type: Object,
      required: false,
    },
  },
  data() {
    return { CaseModel };
  },
  computed: {
    computedValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
        this.$emit("change");
      },
    },
  },
  watch: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    updateWhereAssigned(id, name) {
      this.project.storages.forEach((storage) => {
        if (storage.services.reserves) {
          const reservesAssigned = storage.services.reserves.filter(
            (r) => r.projectReserveId === id
          );
          reservesAssigned.forEach((r) => {
            Object.assign(r, { name });
          });
        }
      });
      this.$emit("change");
    },
  },
};
</script>

<style></style>
